import { CancelToken } from 'axios';
import { appConfig } from '../config/app-config';
import { DATE_FORMAT_API } from '../constants/constants';
import { GetMessagesDTO, SendFreeTextMessageDTO } from '../types/types';
import { formatDate } from '../utils/utils';
import { client } from './client';

export const getTextMessages = (
  customerId: string | number,
  duration: number,
  cancelToken?: CancelToken
): Promise<GetMessagesDTO> => {
  const date = new Date();
  date.setDate(new Date().getDate() - duration);
  const startDate = formatDate(date, DATE_FORMAT_API);
  // Note: ent_party_id is no longer needed, refer AMR-691
  return client(
    `text-message/get-customer-messages?customerId=${customerId}&startDate=${startDate}`,
    { method: 'GET', cancelToken },
    appConfig.apiUrls.micro
  );
};

export const sendTextMessage = (
  textMessage: SendFreeTextMessageDTO
): Promise<void> => {
  return client('text-message/send-message', {
    method: 'POST',
    body: { ...textMessage },
  });
};
